export enum SalePropType {
    Outlined = 'outlined',
    Filled = 'filled',
    Round = 'round',
};
